import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { JobService } from 'src/@core/services/job/job.service';

@Component({
  selector: 'hour4u-admin-adjust-icp',
  templateUrl: './adjust-icp.component.html',
  styleUrls: ['./adjust-icp.component.scss']
})
export class AdjustIcpComponent implements OnInit {
  icpProfile: any = {};
  newCriterionName: string = '';
  newSkillName: string = '';
  newCriteriaName: string = '';
  newCriteriaValue: string = '';
  showAddCriterion: boolean = false;
  isLoading: boolean;
  newCriteriaInputs: { name: string, value: string }[] = [];

  constructor(
    private dialogRef: MatDialogRef<AdjustIcpComponent>,
    private jobService: JobService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data && this.data.icpProfile) {
      this.icpProfile = this.data.icpProfile;
    }
  }

  getIcpKeys(): string[] {
    return Object.keys(this.icpProfile || {});
  }

  close() {
    this.dialogRef.close();
  }

  removeSkill(skill: string) {
    const skills = this.icpProfile['skills'] && this.icpProfile['skills'].value;
    if (skills && Array.isArray(skills)) {
      const index = skills.indexOf(skill);
      if (index > -1) {
        skills.splice(index, 1);
      }
    }
  }
  addSkill() {
    const trimmed = this.newSkillName.trim();
    if (!trimmed) return;

    if (!this.icpProfile['skills']) {
      this.icpProfile['skills'] = { value: [], weight: '0' };
    }

    if (!Array.isArray(this.icpProfile['skills'].value)) {
      this.icpProfile['skills'].value = [];
    }

    if (!this.icpProfile['skills'].value.includes(trimmed)) {
      this.icpProfile['skills'].value.push(trimmed);
      this.newSkillName = '';
    }
  }

  removeCriterion(criterion: string) {
    if (this.icpProfile[criterion]) {
      delete this.icpProfile[criterion];
    }
  }

  addCustomCriterion() {
    if (!this.newCriteriaName || !this.newCriteriaValue) return;
    const key = this.newCriteriaName.trim().toLowerCase().replace(/\s+/g, '_');
    this.icpProfile[key] = {
      value: this.newCriteriaValue.trim(),
      weight: '0'
    };
    this.newCriteriaName = '';
    this.newCriteriaValue = '';
  }

  updateICP() {
    this.isLoading = true;

    // Merge new criteria inputs into icpProfile
    for (const criterion of this.newCriteriaInputs) {
      if (criterion.name && criterion.value) {
        const key = criterion.name.trim().toLowerCase().replace(/\s+/g, '_');
        this.icpProfile[key] = {
          value: criterion.value.trim(),
          weight: '0'
        };
      }
    }

    this.dialogRef.close({
      triggerUpdate: true,
      icpProfile: this.icpProfile,
      entityId: this.data.entityId,
      projectId: this.data.projectId
    });
  }

  removeNewCriterion(index: number) {
    if (this.newCriteriaInputs && index >= 0 && index < this.newCriteriaInputs.length) {
      this.newCriteriaInputs.splice(index, 1);
    }
  }
  addEmptyCriterion() {
    if (!this.newCriteriaInputs) {
      this.newCriteriaInputs = [];
    }
    this.newCriteriaInputs.push({ name: '', value: '' });
  }
}